import React, { useState } from 'react';
import Modal from '../../../components/ui/Modal';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const HighPriorityModal = ({ isOpen, onClose, onSetPriority }) => {
  const [priorityData, setPriorityData] = useState({
    clientId: '',
    priorityLevel: '',
    reason: '',
    assignedTo: '',
    deadline: '',
    actionRequired: '',
    notes: ''
  });

  const handleChange = (field, value) => {
    setPriorityData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    onSetPriority?.(priorityData);
    onClose();
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      title="إدارة العملاء ذوي الأولوية العالية" 
      size="md"
      footer={null}
      icon={null}
      iconColor={null}
    >
      <div className="space-y-4">
        <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-4 mb-4">
          <div className="flex items-center gap-2 text-red-400">
            <Icon name="AlertCircle" size={20} />
            <span className="font-semibold">تعيين أولوية عالية للعميل</span>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">رقم العميل</label>
          <Input
            placeholder="مثال: CL-2026-001"
            value={priorityData?.clientId}
            onChange={(e) => handleChange('clientId', e?.target?.value)}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">مستوى الأولوية</label>
          <Select
            value={priorityData?.priorityLevel}
            onChange={(e) => handleChange('priorityLevel', e?.target?.value)}
          >
            <option value="">اختر المستوى</option>
            <option value="urgent">عاجل جداً</option>
            <option value="high">عالي</option>
            <option value="medium-high">متوسط - عالي</option>
          </Select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">سبب الأولوية</label>
          <Select
            value={priorityData?.reason}
            onChange={(e) => handleChange('reason', e?.target?.value)}
          >
            <option value="">اختر السبب</option>
            <option value="hot-lead">عميل محتمل قوي</option>
            <option value="high-value">قيمة صفقة عالية</option>
            <option value="vip-referral">إحالة من عميل VIP</option>
            <option value="time-sensitive">حساس للوقت</option>
            <option value="competitor-threat">تهديد منافس</option>
            <option value="closing-soon">قريب من الإغلاق</option>
          </Select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">تعيين إلى</label>
          <Select
            value={priorityData?.assignedTo}
            onChange={(e) => handleChange('assignedTo', e?.target?.value)}
          >
            <option value="">اختر الموظف</option>
            <option value="manager">مدير المبيعات</option>
            <option value="senior-agent">وكيل أول</option>
            <option value="specialist">أخصائي VIP</option>
          </Select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">الموعد النهائي</label>
          <Input
            type="date"
            value={priorityData?.deadline}
            onChange={(e) => handleChange('deadline', e?.target?.value)}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">الإجراء المطلوب</label>
          <Select
            value={priorityData?.actionRequired}
            onChange={(e) => handleChange('actionRequired', e?.target?.value)}
          >
            <option value="">اختر الإجراء</option>
            <option value="immediate-contact">تواصل فوري</option>
            <option value="property-viewing">ترتيب معاينة</option>
            <option value="proposal-preparation">إعداد عرض</option>
            <option value="negotiation">مفاوضات</option>
            <option value="contract-preparation">إعداد عقد</option>
          </Select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">ملاحظات إضافية</label>
          <textarea
            className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
            rows="3"
            placeholder="أضف ملاحظات مهمة..."
            value={priorityData?.notes}
            onChange={(e) => handleChange('notes', e?.target?.value)}
          />
        </div>

        <div className="flex gap-3 pt-4">
          <Button onClick={handleSubmit} className="flex-1 bg-red-600 hover:bg-red-700">
            <Icon name="Flag" size={18} className="ml-2" />
            تعيين الأولوية
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default HighPriorityModal;